import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import PrioritariosConfForm from './prioritarios-conf-form';
import PrioritariosConfContent from './prioritarios-conf-content';
import {error, success} from '../../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';

interface PrioritariosConfState {
    lineas: mirana.IPrioritarioLinea[];
    totalLineas: number;
    fuerzaVentaId?: string;
}

class PrioritariosConf extends React.PureComponent<ReduxProps, PrioritariosConfState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.state = {
            lineas: [],
            totalLineas: 0
        };
        this.buscarPrioritariosInfo = this.buscarPrioritariosInfo.bind(this);
    };

    public async buscarPrioritariosInfo(values) {
        const fuerzaVentaId = values.fuerzaVentaId ? values.fuerzaVentaId.value : '';
        try {
            const prioritariosResponse = await this.apiClient.obtenerPrioritariosLineas(fuerzaVentaId);
            this.setState({
                lineas: prioritariosResponse.lineas,
                totalLineas: prioritariosResponse.totalLineas,
                fuerzaVentaId
            });
            this.props.dispatch(success('Notificación', 'Líneas encontradas'));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error al buscar información de líneas'));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Prioritarios Configuración</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <PrioritariosConfForm onSubmit={this.buscarPrioritariosInfo}/>
                    </Col>
                    <Col md={9}>
                        <PrioritariosConfContent lineas={this.state.lineas} totalLineas={this.state.totalLineas}
                                                 fuerzaVentaId={this.state.fuerzaVentaId}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(PrioritariosConf);



// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/configuracion/prioritarios-conf.tsx